import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const colorMap = {
    1: '#1976d2', // blue
    2: '#fbc02d', // yellow
    3: '#f57c00', // orange
    4: '#7b1fa2', // purple
    5: '#00897b', // teal
    6: '#c2185b', // pink
    7: '#455a64', // gray
    8: '#afb42b', // lime
    9: '#388e3c', // green
    10: '#d32f2f', // red
    11: '#8d6e63', // brown
    12: '#00bcd4', // cyan
    13: '#e91e63', // magenta
    14: '#ffeb3b', // bright yellow
    15: '#009688', // teal
    16: '#ff9800', // deep orange
    17: '#4caf50', // medium green
    18: '#3f51b5', // indigo
    19: '#9c27b0', // violet
    20: '#607d8b', // blue gray
    21: '#bdbdbd', // light gray
    22: '#f44336', // vivid red
    23: '#8bc34a', // light green
    24: '#00acc1', // blue teal
    25: '#f06292', // light pink
    26: '#ba68c8', // lavender
    27: '#ffd54f', // pale yellow
    28: '#a1887f', // taupe
    29: '#90caf9', // sky blue
    30: '#a5d6a7', // mint green
    31: '#ce93d8', // light purple
    32: '#ffb300', // gold
    33: '#e57373', // salmon
    34: '#64b5f6', // light blue
    35: '#81c784', // light green
    36: '#9575cd', // light indigo
    37: '#ff8a65', // coral
    38: '#4dd0e1', // turquoise
    39: '#7986cb', // muted blue
    40: '#d4e157', // chartreuse
    41: '#ffd740', // yellow-orange
    42: '#b2dfdb', // pale teal
    43: '#ff5252', // hot red
    44: '#cfd8dc', // pale blue gray
    45: '#e0e0e0', // very light gray
    46: '#b39ddb', // pastel purple
    47: '#ff7043', // orange red
    48: '#aed581', // light lime
    49: '#e6ee9c', // pale lime
    50: '#fff176', // lemon
};

function getRange(allPoints, uniqueValues) {
    return uniqueValues.map(val => {
        const value = val.toString();
        return {
            min: value,
            max: value,
            color: colorMap[value],
            value,
        };
    });
}

export default function GpsSatellitesOverlay({ routes }) {
    // routes: array of segments (arrays of points)
    const allPoints = useMemo(() => routes.flat(), [routes]);
    const uniqueValues = useMemo(() => {
        const set = new Set();
        allPoints.forEach(pt => {
            if (
                pt.gpsNumSats !== undefined &&
                pt.gpsNumSats !== null &&
                pt.gpsNumSats !== '' &&
                !isNaN(Number(pt.gpsNumSats))
            ) {
                set.add(Number(pt.gpsNumSats));
            }
        });
        return Array.from(set).sort((a, b) => a - b);
    }, [allPoints]);
    const finalRanges = useMemo(
        () => getRange(allPoints, uniqueValues),
        [allPoints, uniqueValues]
    );
    const valueSelector = pt => pt.gpsNumSats;
    const legendFormatter = r => r.value;

    // Pass all segments at once, let overlay handle rendering and legend
    return (
        <SegmentedPolylineOverlay
            segments={routes}
            valueSelector={valueSelector}
            ranges={finalRanges}
            legendTitle="Gps Satellites (#)"
            legendFormatter={legendFormatter}
            units=""
            discrete={true}
        />
    );
}